import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

import StudentStat from './StudentStat'
import {
  displayNumberRoundedToTenth,
  displayNumberAsPercentage
} from '../../../utils'
import {
  hasCompletedQuests,
  formatQuestCountDisplay
} from '../../../utils/userstats'

const StudentStats = props => {
  const hasNoCompletedQuests = !hasCompletedQuests(props.stats)

  return (
    <div
      className={`student-stats ${
        props.multipleVersionsExist ? 'multipleVersionsExist' : ''
      }`}
    >
      <div className="label-wrapper">
        <div className="label">student stats</div>
        {props.multipleVersionsExist && (
          <React.Fragment>
            <ReactTooltip
              id="publishedStats"
              effect="solid"
              offset={{ bottom: 8 }}
            />
            <div
              data-for="publishedStats"
              data-tip="Stats for published versions of this quest"
              className="previous-versions"
            >
              Previous Versions
            </div>
          </React.Fragment>
        )}
      </div>
      <div className="stats-wrapper">
        <StudentStat
          type="average_learner_rating"
          value={displayNumberRoundedToTenth(
            props.stats.average_learner_rating
          )}
          hasNoCompletedQuests={hasNoCompletedQuests}
          formatEmptyWithNA
          multipleVersionsExist={props.multipleVersionsExist}
        />
        <div className="vertical-divider" />

        <StudentStat
          type="average_learner_effort"
          value={displayNumberRoundedToTenth(
            props.stats.average_learner_effort
          )}
          hasNoCompletedQuests={hasNoCompletedQuests}
          formatEmptyWithNA
          multipleVersionsExist={props.multipleVersionsExist}
        />
        <div className="vertical-divider" />

        <StudentStat
          type="percent_quests_recommended"
          value={displayNumberAsPercentage(
            props.stats.percent_quests_recommended
          )}
          hasNoCompletedQuests={hasNoCompletedQuests}
          formatEmptyWithNA
          multipleVersionsExist={props.multipleVersionsExist}
        />
        <div className="vertical-divider" />

        <StudentStat
          type="quests_in_progress_by_learners_count"
          value={formatQuestCountDisplay(props.stats.quests_in_progress_count)}
          hasNoCompletedQuests={hasNoCompletedQuests}
          multipleVersionsExist={props.multipleVersionsExist}
        />
        <div className="vertical-divider" />

        <StudentStat
          type="quests_completed_by_learners_count"
          value={formatQuestCountDisplay(props.stats.quests_completed_count)}
          hasNoCompletedQuests={hasNoCompletedQuests}
          multipleVersionsExist={props.multipleVersionsExist}
        />
      </div>
    </div>
  )
}

StudentStats.propTypes = {
  stats: PropTypes.object.isRequired,
  multipleVersionsExist: PropTypes.bool.isRequired
}

export default StudentStats



// WEBPACK FOOTER //
// ./src/components/quest/studentstats/StudentStats.js